import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import DeveloperProfile from './DeveloperProfile';
import BlogSection from './BlogSection';
import SkillsSection from './SkillsSection';
import ThemeToggle from './ThemeToggle';
import SkipToContent from './SkipToContent';
import './Portfolio.css';

const Portfolio: React.FC = () => {
  const { t } = useLanguage();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop() || 'about';


  return (
    <div className="portfolio-container">
      <SkipToContent />
      <ThemeToggle />
      <header className="portfolio-header">
        <div className="header-content">
          <h1>{t('portfolio.name')}</h1>
          <p>{t('portfolio.title')}</p>
        </div>
      </header>

      <nav className="portfolio-nav" role="navigation" aria-label="Main navigation">
        <div className="nav-container">
          <Link 
            to="/portfolio/about"
            className={currentPath === 'about' ? 'nav-btn active' : 'nav-btn'}
            aria-current={currentPath === 'about' ? 'page' : undefined}
          >
            <span className="nav-icon">👤</span>
            {t('nav.about')}
          </Link>
          <Link 
            to="/portfolio/skills"
            className={currentPath === 'skills' ? 'nav-btn active' : 'nav-btn'}
            aria-current={currentPath === 'skills' ? 'page' : undefined}
          >
            <span className="nav-icon">🛠️</span>
            {t('nav.skills')}
          </Link>
          <Link 
            to="/portfolio/blog"
            className={currentPath === 'blog' ? 'nav-btn active' : 'nav-btn'}
            aria-current={currentPath === 'blog' ? 'page' : undefined}
          >
            <span className="nav-icon">📝</span>
            {t('nav.blog')}
          </Link>
        </div>
      </nav>

      <main className="portfolio-main" id="main-content" tabIndex={-1}>
        <div className="content-container">
          <Routes>
            <Route path="/" element={<DeveloperProfile />} />
            <Route path="/about" element={<DeveloperProfile />} />
            <Route path="/skills" element={<SkillsSection />} />
            <Route path="/blog" element={<BlogSection />} />
          </Routes>
        </div>
      </main>

      <footer className="portfolio-footer">
        <div className="footer-content">
          <p>{t('portfolio.footer')}</p>
          <div className="social-links">
            <button type="button" className="link-button" aria-label={t('portfolio.social.linkedin')}>{t('portfolio.social.linkedin')}</button>
            <button type="button" className="link-button" aria-label={t('portfolio.social.github')}>{t('portfolio.social.github')}</button>
            <button type="button" className="link-button" aria-label={t('portfolio.social.email')}>{t('portfolio.social.email')}</button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Portfolio;